import { FC } from "react";

import ItemContainer from "@app/containers/item";

const AddItemPage: FC = () => <ItemContainer />;

export default AddItemPage;
